import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import DocumentationForm from './DocumentationForm';
import DocumentationFilter from './DocumentationFilter';

function Documentation() {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = React.useState<string>(`${currentYear}`);

  return (
    <Stack px={3} py={4} height='100%' overflow='auto scroll'>
      <Typography fontSize='1.5rem' mb={4}>
        Sonstige Dokumentation
      </Typography>
      <Stack direction='column' px={1} maxWidth='650px'>
        <DocumentationFilter setYear={setYear} year={year} filterStartYear={2022} />
      </Stack>
      <DocumentationForm year={year} />
    </Stack>
  );
}

export default Documentation;
